import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Checkbox, Tooltip } from '@mui/material';

EmailBookingTypeForm.propTypes = {
  setRule: PropTypes.func,
  formValue: PropTypes.object,
};

const ruleIds = {
  alwaysUsePSPDF: 19,
  dontIncludeOrderPDF: 20
};

export default function EmailBookingTypeForm({ formValue, setRule }) {

  const rules = useMemo(() => {
    if (!formValue.rules) return {};
    return {
      alwaysUsePSPDF: formValue.rules.find(rule => rule.id === ruleIds.alwaysUsePSPDF),
      dontIncludeOrderPDF: formValue.rules.find(rule => rule.id === ruleIds.dontIncludeOrderPDF)
    };
  }, [formValue.rules]);

  return <>  
    <Tooltip title="Always use the generated PS PDF even if the vendor's PDF exists (note does not replace the PDF on our system, just sends a PS version on the email). Mostly for facilities who want the GL codes on the PDF." arrow placement="left">
      <FormControlLabel control={<Checkbox checked={rules.alwaysUsePSPDF ?? false} onChange={(e) =>
        setRule(ruleIds.alwaysUsePSPDF, e.target.checked ? { id: ruleIds.alwaysUsePSPDF } : null)} />} label="Always use PS generated PDF" />
    </Tooltip>
    <Tooltip title="Don't include order PDF on the email when sending the invoice." arrow placement="left">
      <FormControlLabel control={<Checkbox checked={rules.dontIncludeOrderPDF ?? false} onChange={(e) =>
        setRule(ruleIds.dontIncludeOrderPDF, e.target.checked ? { id: ruleIds.dontIncludeOrderPDF } : null)} />} label="Don't include order PDF" />
    </Tooltip>
  </>;
}
